import React from 'react';
import classnames from 'classnames';
import styles from './Label.scss';

/**
 * Looks like a label but doesn't have an associated input.
 * Used to provide a label for a section of a form
 **/

const SectionHeader = ({ children, className, ...props }) => {
  return (
    <h2
      {...props}
      className={classnames(styles.Label, styles.SectionHeader, className)}
    >
      {children}
    </h2>
  );
};
export default SectionHeader;
